import {formatPlateForDisplay} from "./format-plate-for-display";
import type {ShiftCompanyVehicleRef} from "./shift-company-vehicles";

/** Compact line for patrol vehicle rows, e.g. `Unit 22 7BCP907` (unit + plate). */
export function formatPatrolVehicleDisplay(v: ShiftCompanyVehicleRef): string {
  const plate = formatPlateForDisplay(v.plate);
  const unit = (v.unit_number ?? "").trim();

  if (unit && plate) return `Unit ${unit} ${plate}`;
  if (unit) return `Unit ${unit}`;
  if (plate) return plate;

  const name = v.name?.trim();
  if (name) return name;
  return `Vehicle #${v.id}`;
}
